<!--
 * @Author: 王枫叶
 * @Date: 2020-10-24 13:45:37
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-21 19:55:57
-->
<!--  -->
<template>
  <div>
    <el-dialog id="activity"  title="本书一键配置" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="300px" center calss="ac-dialog" append-to-body>
      <div class="ac-dia-form" >
        <el-form ref="ruleForm" :model="params" :rules='rules' size="mini" label-width="80px" label-position="left">
          <el-form-item label="收听权限:" prop="listenPermission">
            <el-select
              v-model.number="params.listenPermission"
              size="small"
              placeholder="请选择类型"
              clearable
            >
              <el-option
                v-for="item in listenPermissions"
                :value="item.value"
                :label="item.label"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单价:" prop="price" v-if="params.listenPermission===1">
            <el-input v-model.number="params.price" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import {validatorIn} from '@/utils/validator'
export default {
  props: ['params_detail','checkedepisodeNumbers'],
  data() {
    return {
      dialogFormVisible: false,
      params: {
        listenPermission: '',
        price: 10,
      },
      listenPermissions: [
        { label: '会员', value: 0 },
        { label: '金币购买', value: 1 },
        { label: '试听', value: 3 },
      ],
      rules:{
      price: [
          {  message: "请输入正整数",validator: validatorIn, trigger: "blur" },
        ],
      }      
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //给勾选项的单价和收听权限赋值：selectedContentSet
          let selectedContentSet=this.params_detail.contentSet.map(item=>{
            if( this.checkedepisodeNumbers.indexOf(item.episodeNumber)!==-1 )
            {
              item.price= this.params.listenPermission !== 1 ? 0 : this.params.price
              item.listenPermission=this.params.listenPermission
            }
         let  obj=Object.assign({},item,{price:item.price},{ listenPermission: item.listenPermission})
            return obj
          })
          //确定提交表单时的 传参对象param
          const param = Object.assign({}, this.params_detail, { contentSet:selectedContentSet})
          API.updateAudiobook(param).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: '编辑成功',
                type: 'success',
              })
            this.$emit('getAudiobook')            
              this.dialogFormVisible = false
            } else {
              this.$message.error('编辑失败,请重试')
              this.dialogFormVisible = false
            }
          })
        } else {
          return false
        }
      })
    },
    // 取消
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$emit('handlerChannel')
      this.dialogFormVisible = false
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogFormVisible = true
      this.params.price = data
    },
  },
}
</script>

<style lang='' scoped>
</style>
